import * as types from "./../types/types";

const initialState = {
  myProject: [],
  allProjects: [],
  loading: true,
  error: null,
  pmList: [],
  bu: "",
  region: "",
};

const ProjectReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.GET_PROJECT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        myProject: payload,
        pmList: payload,
      };
    case types.GET_PROJECT_DETAILS_SUCCESS:
      return {
        ...state,
        myProject: payload,
        loading: false,
        error: null,
      };

    case types.GET_OWNER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        pmList: payload,
      };
    case types.GET_PROJECT_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.GET_PROJECT_COMPLETE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        myProject: payload,
        pmList: payload,
      };
    case types.GET_PROJECT_COMPLETE_DETAILS_SUCCESS:
      return {
        ...state,
        myProject: payload,
        loading: false,
        error: null,
      };

    case types.GET_OWNER_COMPLETE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        pmList: payload,
      };
    case types.GET_PROJECT_COMPLETE_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };  
    case types.GET_ALL_PROJECT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        allProjects: payload,
        pmList: payload,
      };
    case types.GET_ALL_PROJECT_DETAILS_SUCCESS:
      return {
        ...state,
        allProjects: payload,
        loading: false,
        error: null,
        pmList: payload,
      };

    case types.GET_ALL_PROJECT_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.GET_ALL_PROJECT_COMPLETE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        myProject: payload,
        pmList: payload,
      };
    case types.GET_ALL_PROJECT_COMPLETE_DETAILS_SUCCESS:
      return {
        ...state,
        allProjects: payload,
        loading: false,
        error: null,
        pmList: payload,
      };

    case types.GET_ALL_PROJECT_COMPLETE_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };  
    case types.UPDATE_PROJECT:
      const { projectId, comment } = action.payload;
      return {
        ...state,
        myProject: state.myProject && Array.isArray(state.myProject) 
          ? state.myProject.map(project =>
              project.Project_ID === projectId
                ? { ...project, ProjectStatusComment: comment }
                : project
            )
          : state.myProject,
        allProjects: state.allProjects && Array.isArray(state.allProjects)
          ? state.allProjects.map(project =>
              project.Project_ID === projectId
                ? { ...project, ProjectStatusComment: comment }
                : project
            )
          : state.allProjects
      };
    case types.UPDATE_BU_REGION:
      return {
        ...state,
        bu: payload.bu,
        region: payload.region
      };
    default:
      return state;
  }
};
export default ProjectReducer;
